<template>
    <div>
        <v-card-text>
            <v-row>
                <v-col cols="2">
                    <div>
                        <v-radio-group
                            v-model="mtype"
                            column
                            @change="callAnnouncement"
                        >
                            <template v-slot:label>
                                <div style="color: black;font-weight: bold;">Announcement Category</div>
                            </template>
                            <v-radio
                                :key="i" v-for="(data,i) in messagetypes"
                                :label="data.label"
                                :value="data.value"
                                style="height: 80px;"
                                color="#D4C88D"
                            ></v-radio>
                        </v-radio-group>
                    </div>
                </v-col>
                <v-col cols="10">
                    <div style="height: 100%;">
                        <Announcements :messageData="messageData" :messageType="mtype" v-if="renderok" />
                        <v-row
                            v-else-if="!renderok"
                            class="fill-height"
                            align-content="center"
                            justify="center"
                        >   
                            <v-col class="text-center">
                                <v-progress-circular
                                    :size="50"
                                    color="#D4C88D"
                                    indeterminate
                                ></v-progress-circular>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import Announcements from "./Announcements.vue"

export default {
    components: {
        Announcements
    },
    data() {
        return {
            host: location.hostname.toString(),
            messagetypes: [
                {label: "Home", value: "home"},
                {label: "Statement", value: "statement"},
                {label: "T4A", value: "t4a"},
                {label: "T2202A", value: "t2202a"},
                {label: "Net Bill", value: "netbill"}
            ],
            mtype: "home",
            messageData: {},
            renderok: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500
        }
    },
    methods: {
        callAnnouncement(){
            const that = this;
            that.renderok = false;
            that.messageData = {
                "class" : "info",
                "title" : null,
                "text" : null,
                "display" : "no"
            };
            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?adminAnnouncementsGet';

            //API GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#FFCC80"); //orange
                    }
                    if(resultData.data){
                        for(var i=0; i < resultData.data.length; i++){
                            if(resultData.data[i].type == that.mtype){
                                that.messageData = resultData.data[i];
                            }
                        }
                    }else {
                        that.setSnackbar("Warning: "+resultData.message, "#FFCC80"); //orange
                    }

                    that.renderok = true;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API GET request
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.callAnnouncement();
    }
}
</script>